<template>
  <v-dialog v-model="internalValue" max-width="650px" persistent scrollable>
    <v-card class="rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between border-light-bottom bg-white">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-account-multiple-plus</v-icon>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            Carga Masiva de Participantes
          </span>
        </div>
        <v-btn icon small @click="close">
          <v-icon color="grey darken-2">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-5 px-6">
        <!-- Selector de Modo de Carga Masiva: Por Área o Por Cargo -->
        <v-btn-toggle v-model="bulkMode" mandatory dense class="mb-4 rounded-lg border-light d-flex">
          <v-btn value="area" class="flex-grow-1 text-none font-weight-bold" active-class="primary white--text">
            <v-icon left small>mdi-domain</v-icon>
            Cargar por Área
          </v-btn>
          <v-btn value="position" class="flex-grow-1 text-none font-weight-bold" active-class="primary white--text">
            <v-icon left small>mdi-badge-account-horizontal</v-icon>
            Cargar por Cargo / Puesto
          </v-btn>
        </v-btn-toggle>

        <v-alert dense text color="info" class="text-caption rounded-lg mb-4">
          <v-icon x-small color="info" class="mr-1">mdi-shield-check</v-icon>
          Se filtrarán automáticamente solo los colaboradores con <b>contratos laborales activos</b>. Si ya se encuentran inscritos en el evento, se omitirán para evitar duplicidades.
        </v-alert>

        <v-row dense>
          <!-- Modo Área -->
          <v-col cols="12" v-if="bulkMode === 'area'">
            <s-select-area
              label="Seleccionar Área a Enrolar *"
              v-model="selectedAreaID"
              clearable
            />
          </v-col>

          <!-- Modo Cargo / Puesto -->
          <v-col cols="12" v-if="bulkMode === 'position'">
            <s-select-position
              label="Seleccionar Puesto / Cargo a Enrolar *"
              v-model="selectedPositionID"
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-3 px-6 justify-end bg-white">
        <v-btn text class="rounded-lg text-none font-weight-bold grey--text text--darken-3 px-4" @click="close">
          Cancelar
        </v-btn>
        <v-btn color="primary" class="rounded-lg text-none font-weight-bold px-6 white--text" elevation="0" :loading="saving" @click="executeBulk">
          <v-icon left small>mdi-account-multiple-plus</v-icon>
          Iniciar Carga Masiva
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SSelectArea from "@/components/Utils/SSelectArea.vue";
import SSelectPosition from "@/components/Utils/sSelectPosition.vue";
import TrainingParticipantService from "@/services/Management/TrainingParticipantService";

export default {
  name: "TrainingParticipantBulkModal",
  components: {
    SSelectArea,
    SSelectPosition,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tevID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      bulkMode: "area",
      selectedAreaID: null,
      selectedPositionID: null,
      saving: false,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.selectedAreaID = null;
        this.selectedPositionID = null;
      }
    },
  },
  methods: {
    close() {
      this.internalValue = false;
    },
    executeBulk() {
      if (!this.tevID) {
        this.$fun.alert("Evento no seleccionado. Seleccione un evento previamente.", "error");
        return;
      }

      if (this.bulkMode === "area" && !this.selectedAreaID) {
        this.$fun.alert("Seleccione un área para cargar.", "warning");
        return;
      }
      if (this.bulkMode === "position" && !this.selectedPositionID) {
        this.$fun.alert("Seleccione un puesto / cargo para cargar.", "warning");
        return;
      }

      const confirmMsg = this.bulkMode === "area"
        ? "¿Está seguro de enrolar masivamente a todos los colaboradores del área seleccionada?"
        : "¿Está seguro de enrolar masivamente a todos los colaboradores con el cargo seleccionado?";

      this.$fun.alert(confirmMsg, "question").then((r) => {
        if (r && r.value) {
          this.saving = true;
          const reqId = this.$fun.getUserID();

          const promise = this.bulkMode === "area"
            ? TrainingParticipantService.bulkArea({ TevID: this.tevID, AreID: this.selectedAreaID }, reqId)
            : TrainingParticipantService.bulkPosition({ TevID: this.tevID, PstID: this.selectedPositionID }, reqId);

          promise
            .then((res) => {
              const enrolled = res.data?.TotalEnrolled || 0;
              this.$fun.alert(`Carga masiva completada: ${enrolled} colaboradores agregados con éxito.`, "success");
              this.$emit("enrolled");
              this.close();
            })
            .catch((err) => {
              this.$fun.alert(err?.response?.data?.Message || "Error durante la carga masiva.", "error");
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
  },
};
</script>
